import React, { useState, useEffect, useRef } from 'react';
import { AutoComplete, Tag, Row, Col, Button } from 'antd';
import Search from 'antd/lib/input/Search';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faRedo, faBoxCheck, faMinus, faExchangeAlt } from '@fortawesome/pro-duotone-svg-icons';
import { useAxios } from '../../hooks';
import { Dinheiro } from '../';
import './AutoCompleteProduto.scss';
import { useSelector, useDispatch} from 'react-redux'
//import { reducerProdutosTypes } from '../../store/reducer-produtos';




const AutoCompleteProduto = ({autoCompleteProps, searchProps, onSelect, produtoSelecionadoInicial/* , reducerProdutos */}) => {
    
    
    /* const {stateProdutos, dispatchProdutos} = reducerProdutos; */
    const reducerProd = useSelector((state) => state.reducerProdutos)
    const produtos = reducerProd.produtos;
    //const {produtos, loading} = stateProdutos;
    const [options, setOptions] = useState([]);
    // const [loading, setLoading] = useState(false);
    const [produtoSelecionado, setProdutoSelecionado] = useState(produtoSelecionadoInicial);
    const dispatch = useDispatch();

    useEffect(() => {
        filtraProdutos("");
    }, []);

    const buscarProdutos = async () => {
         console.log("reducerProdutosTypes",reducerProd.reducerProdutosTypes.BUSCAR_PRODUTOS)
        try{
            dispatch({type: reducerProd.reducerProdutosTypes.BUSCAR_PRODUTOS});
        } catch(e){
            console.log(e);
        }
    } 

    const filtraProdutos = (termo) => {
        termo = termo? termo.toUpperCase() : "" ;

        const produtosFiltrados = produtos.filter(p => ( 
                            p.descricao.toUpperCase().indexOf(termo) >=0 || p.codigo.toUpperCase().indexOf(termo) >= 0
                        ));
        // setProdutosFiltrados(produtosFiltrados);
        defineOptions(produtosFiltrados);
    }

    const defineOptions = (produtosFiltrados) => {
        const options = produtosFiltrados.map(p => {
            return {
                value: p.uuid,
                label: (<div className="item-wrapper">
                            <span className='titulo'>
                                {p.codigo} - {p.descricao.toUpperCase()}
                            </span>
                            <span className='preco'>
                                <Tag><Dinheiro value={p.vUnCom}></Dinheiro></Tag>

                            </span>
                    
                    
                </div>)
            }
        });
        setOptions(options);
    }

    const selecionaProduto = (uuidProduto)=>{
        
        const produto = produtos.filter(p => p.uuid == uuidProduto)[0]
        setProdutoSelecionado(produto);
        onSelect && onSelect(produto);

    }

    const removerSelecaoProduto = () => {
        setProdutoSelecionado(false);
        onSelect && onSelect(false);
    }

    
    if(produtoSelecionado){
        return (<Row className="produtoTag">
            <Col>
                <FontAwesomeIcon icon={faBoxCheck} size="3x"></FontAwesomeIcon>
            </Col>
            <Col>
                <span className='titulo'>
                    {produtoSelecionado.descricao}
                </span>
                <span className='descricao'>
                    Código: {produtoSelecionado.codigo} | EAN: {produtoSelecionado.eanCom}
                </span>
            </Col>
            <Col className='button-wrapper' >
                <Button type="text" siza="small" onClick={removerSelecaoProduto}><FontAwesomeIcon icon={faExchangeAlt}></FontAwesomeIcon> Trocar</Button>
            </Col>
        </Row>);
    } else {

        return <>
            <AutoComplete {...autoCompleteProps} 
                options={options}
                onSearch={filtraProdutos}
                onSelect={selecionaProduto}
                
                
            >
                <Search 
                    /* loading={loading} */
                    onSearch={buscarProdutos}
                    onPressEnter={evt => {}}
                    {...searchProps}
                    autoFocus={true}
                    enterButton={<FontAwesomeIcon icon={faRedo} ></FontAwesomeIcon>}>
                </Search>
            </AutoComplete>
        </>;
    }

}

export {AutoCompleteProduto}